import { z } from "zod";
export const CreateExtractionBody = z.discriminatedUnion("source_type", [
    z.object({ source_type: z.literal("file"), source_ref: z.string().min(1) }), // GCS object key
    z.object({ source_type: z.literal("url"), source_ref: z.string().url() }),
]);
/**
 * Direct-to-GCS upload for source files (P22 large-PDF support).
 * Operator's browser PUTs bytes directly to GCS using the returned signed
 * URL, bypassing Cloud Run's 32 MB ingress and the api's multipart parser.
 * The worker reads + magic-byte-validates the bytes when processing the job.
 */
export const ExtractionUploadUrlBody = z.object({
    content_type: z.enum([
        "application/pdf",
        "image/png",
        "image/jpeg",
        "image/webp",
    ]),
});
export const PatchExtractedItemBody = z.object({
    status: z.enum(["pending", "approved", "rejected"]).optional(),
    // Operator-pasted product image URL → persisted to the `image_url` column
    // (NOT editedJson). Image/PDF extractions can't yield a hosted image URL,
    // so the operator supplies one; promote attaches it to the product. Empty
    // string clears it (maps to null). http(s) URLs only.
    image_url: z
        .union([z.string().url(), z.literal("")])
        .nullable()
        .optional(),
    edited: z
        .object({
        title: z.string().min(1).max(200).optional(),
        variant_label: z.string().max(120).optional(),
        description: z.string().max(5000).optional(),
        pack_size: z.string().max(120).optional(),
        sku: z.string().min(1).max(120).optional(),
        vat_category_code: z.string().min(1).max(50).optional(),
        base_price_minor: z.number().int().positive().optional(),
        min_order_quantity: z.number().int().positive().optional(),
        order_increment: z.number().int().positive().optional(),
        category_path: z.string().max(500).optional(),
    })
        .optional(),
});
